import React from 'react';

import { SnackbarSeverityType } from '../../enums';
import StudentFeeEntryPage from './StudentFeeEntryPage';

interface StudentFeeEntryContainerProps {
  onShowToast: (message: string, severity: SnackbarSeverityType) => void;
  studentId: string;
  onBack: () => void;
}

const StudentFeeEntryContainer: React.FC<StudentFeeEntryContainerProps> = ({
  onShowToast,
  studentId,
  onBack
}) => {
  return (
    <StudentFeeEntryPage
      onShowToast={onShowToast}
      studentId={studentId}
      onBack={onBack}
    />
  );
};

export default StudentFeeEntryContainer;
